import React, { useCallback } from 'react';
import { Button } from './styled';
import { StyledIcon as Icon, IconName } from '../../../../../../Icons';
export const BackButton = ({ onBack, className, color, backgroundColor, }) => {
    const handleClick = useCallback((event) => {
        if (!onBack)
            return;
        onBack();
        event.stopPropagation();
        event.preventDefault();
    }, [onBack]);
    return (React.createElement(Button, { onClick: handleClick, "data-test": "BackButton-Button", testID: "back_button", test: "test", className, backgroundColor },
        React.createElement(Icon, { "data-test": "BackButton-Icon", className: "BackButton-Icon", name: IconName.back, color, backgroundColor })));
};
BackButton.displayName = 'BackButton';
BackButton.defaultProps = {
    color: 'white',
    backgroundColor: 'transparent',
    className: '',
};
//# sourceMappingURL=index.js.map